<!--
FigureTile - a Nuxt.js NuxtContent component from Pennock Projects, MIT License, Copyright (c) 2025-2026 John Pennock
version: 1.0
-->

<script setup>
defineProps({
  article: {
    type: Object,
    default: () => ({
      title: 'default title',
      path: '/',
      image: '',
      image_alt: '',
      isTarget: false
    })
  }
})

</script>

<template>
  <NuxtLink :to="article.path" class="artlink-all not-prose" :target="article.isTarget ? '_blank' : ''">
    <div class="artlink-img-area">
      <img v-if="article.image" :src="article.image" :alt="article.image_alt" class="artlink-image">
    </div>
    <div v-if="article.tagline" class="artlink-para">
      <span class="artlink-text prose dark:prose-invert">
        {{ article.tagline }}
      </span>
    </div>
    <div v-else-if="article.title" class="artlink-para">
      <span class="artlink-text prose dark:prose-invert">
      {{  article.title }}
      </span>
    </div>
  </NuxtLink>
</template>

<style scoped>
.artlink-all {
  @apply block p-0 mb-2 rounded-sm shadow-md max-h-12 max-w-prose overflow-hidden bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 hover:dark:bg-gray-700
}

.artlink-img-area {
  @apply flex justify-center w-1/4 h-10 md:h-12 float-left
}

.artlink-image {
  @apply sm:max-h-10 md:max-h-12 mx-auto sm:h-10 md:h-12 
}

.artlink-para {
  @apply h-10 md:h-12 w-3/4 text-wrap tracking-wide font-semibold no-underline pl-2 overflow-hidden my-0 mx-auto flex flex-col justify-center
}

.artlink-text {
  @apply ml-2 text-sm sm:text-base md:text-lg
}

</style>